import styles from './Zebra.module.scss'
import Top from '../pages/ZEBRA/Top'
import Logo from '../pages/ZEBRA/Logo'
import { Problem } from '../pages/ZEBRA/Problem'
import BestPractice from '../pages/ZEBRA/BestPractice'
import Features from '../pages/ZEBRA/Features'
import Comparison from '../pages/ZEBRA/Comparison'
import Voice from '../pages/ZEBRA/Voice'
import Price from '../pages/ZEBRA/Price'
import Flow from '../pages/ZEBRA/Flow'
import QA from '../pages/ZEBRA/QA'
import { Contact } from '../pages/ZEBRA/Contact'

const ContactFormId = '122b1fb2-c86f-413e-87cc-6a1ebeea3d8f'

const ProblemContents = {
  title: 'こんな課題はありませんか？',
  subTitle: 'プッシュ通知に関するお悩みを解決します',
  list: [
    {
      text: (
        <>
          顧客の属性や行動に合わせた
          <br />
          配信ができない
        </>
      ),
      icon: '/images/LP/LP202407/AmazonECS/Icon/BsGraphUp.svg',
    },
    {
      text: (
        <>
          複数のツールを導入していて
          <br />
          運用が大変
        </>
      ),
      icon: '/images/LP/LP202407/AmazonECS/Icon/BsExclude.svg',
    },
    {
      text: (
        <>
          豊富な分析機能を
          <br />
          使いこなせていない
        </>
      ),
      icon: '/images/LP/LP202407/AmazonECS/Icon/BsShareFill.svg',
    },
  ],
}

const FeaturesContents = {
  title: 'ZEBRAの3つの特長',
  items: [
    {
      src: '/img/LP/zebra/feature_01.webp',
      num: 'FEATURE 01',
      itemTitle: (
        <>
          顧客属性DBを活用した
          <br />
          細やかなセグメント配信
        </>
      ),
      description:
        '顧客属性DBを持つことで、各顧客に最適なメッセージを届けることが可能です。管理画面から簡単に顧客属性や配信スケジュールを編集でき、きめ細かいターゲティングを実現します。',
    },
    {
      src: '/img/LP/zebra/feature_02.webp',
      num: 'FEATURE 02',
      itemTitle: (
        <>
          多彩な配信機能と
          <br />
          カスタマイズ性
        </>
      ),
      description:
        'セグメント配信、予約配信、自動定期配信など多彩な機能を提供。さらに、バッジ表示やロック画面通知など、iOS・Android両方に対応した機能で、効果的な通知を実現します。',
    },
    {
      src: '/img/LP/zebra/feature_03.webp',
      num: 'FEATURE 03',
      itemTitle: (
        <>
          詳細な分析機能と
          <br />
          継続的な最適化
        </>
      ),
      description:
        '開封率やプッシュからのコンバージョンなど、詳細な解析が可能です。これにより、配信効果を測定し、継続的に配信戦略を最適化することができます。',
    },
  ],
}

const VoiceContents = {
  title: 'お客様の声',
  items: [
    {
      num: '01',
      itemTitle: (
        <>
          プッシュ通知のサービスを探していて、
          <br />
          他に選択肢も少なく即決でした
        </>
      ),
      industry: '金融業',
      description: (
        <>
          当初は費用対効果を重視して複数サービスを調べましたが、アプリにマッチできるサービスは少なく、必要なプッシュ通知の機能も満たしていたため即決になりました。
          <br />
          また、アイスリーデザインさんがUIデザインや開発専門の会社ということで、先々の拡張性を考えた際に、社内に知識がなくても安心して利用できると確信し、社内承認もスムーズでした。
        </>
      ),
    },
    {
      num: '02',
      itemTitle: (
        <>
          メジャーなMAツールから
          <br />
          乗り換えました
        </>
      ),
      industry: '小売業',
      description: (
        <>
          多機能さに惹かれMAツールを使っていましたが、どうしてもコストが高く、また、いざプロダクトの運用をはじめると、学習コストをかけて覚えたわりにはプッシュ通知以外は使う機会も少なく、2年ぐらいで乗り変えることになりました。
          <br />
          ZEBRAであれば運用コストも下がり、一部カスタマイズが必要になりましたが、柔軟に対応できるサービスです。
        </>
      ),
    },
  ],
}

const FlowContents = [
  {
    num: 1,
    title: '現状分析',
    description: 'お客さまの顧客コミュニケーション戦略と課題を詳細に分析します。',
    src: '/img/LP/zebra/BsBarChartLine.svg',
  },
  {
    num: 2,
    title: 'ZEBRA環境の設計',
    description: 'お客さまのニーズに合わせた最適なZEBRA環境を設計します。',
    src: '/img/LP/zebra/BsDiagram3.svg',
  },
  {
    num: 3,
    title: '初期設定と導入',
    description: 'ZEBRA環境を構築し、既存システムとの連携をサポートします。',
    src: '/img/LP/zebra/BsWindowSidebar.svg',
  },
  {
    num: 4,
    title: '運用サポートと継続的な最適化',
    description: '配信効果の分析と改善提案を行い、継続的な最適化をサポートします。',
    src: '/img/LP/zebra/BsPersonCheck.svg',
  },
]

const FAQContents = [
  {
    num: 1,
    question: 'ZEBRAはどのような企業に適していますか？',
    answer:
      '顧客とのコミュニケーションを重視し、効果的なプッシュ通知戦略を実現したい企業に適しています。特に、Eコマース、メディア、サービス業など、顧客エンゲージメントが重要な業種におすすめです。',
  },
  {
    num: 2,
    question: '既存のCRMシステムとの連携は可能ですか？',
    answer:
      'はい、可能です。当社の専門チームが、お客さまの既存システムとZEBRAとの最適な連携方法を提案し、スムーズな導入をサポートします。',
  },
  {
    num: 3,
    question: 'カスタマイズは可能ですか？',
    answer:
      'はい、お客さまのニーズに合わせたカスタマイズが可能です。ただし、カスタマイズの内容によっては別途費用が発生する場合があります。',
  },
  {
    num: 4,
    question: 'セキュリティ面はどうなっていますか？',
    answer:
      'ZEBRAは高度なセキュリティ対策を施しています。顧客データの保護や通信の暗号化など、安全な運用を実現します。具体的なセキュリティ対策については、お問い合わせください。',
  },
  {
    num: 5,
    question: '導入後のサポート体制はどうなっていますか？',
    answer:
      '導入後も、継続的にサポートします。定期的な効果分析や改善提案、技術的なサポートなど、お客さまのニーズに応じたサポートを提供します。',
  },
]

const Zebra: React.FC = () => {
  return (
    <div className={styles.resetZebra}>
      <Top />
      <Logo />
      <Problem contents={ProblemContents} />
      <BestPractice />
      <Features contents={FeaturesContents} />
      <Comparison />
      <Voice contents={VoiceContents} />
      <Price />
      <Flow contents={FlowContents} />
      <QA contents={FAQContents} />
      <Contact formId={ContactFormId} />
    </div>
  )
}
export default Zebra
